var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8637 13.2235C13.6358 12.5856 13.1336 12.022 12.435 11.6199C11.7365 11.2179 10.8805 11 10 11C9.11946 11 8.26353 11.2179 7.56496 11.6199C6.86638 12.022 6.3642 12.5856 6.1363 13.2235",
    stroke: "black",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 7,
    r: 2,
    stroke: "black",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9862 15.2237C5.11566 16.5229 6.6309 17.427 8.31065 17.804C9.9904 18.1811 11.7467 18.0112 13.3231 17.3193C14.8994 16.6272 16.2132 15.4492 17.0726 13.9575C17.932 12.4657 18.292 10.7383 18.1 9.02746C17.9082 7.31645 17.1743 5.71159 16.0056 4.44729C14.8368 3.18299 13.2945 2.32548 11.6038 2M8.54608 2.00655C7.41073 2.2252 6.3356 2.68519 5.39344 3.35539C4.45129 4.02559 3.66409 4.89036 3.08513 5.89117C2.50612 6.892 2.14886 8.00554 2.03753 9.15642C1.92621 10.3073 2.06342 11.4687 2.43987 12.5619",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser1);
export default __webpack_public_path__ + "static/media/User1.805a7c89a5463f8535bbae5c09c45dc0.svg";
export { ForwardRef as ReactComponent };